import React from 'react';
import type { TFunction } from 'i18next';
import { useIntl, type IntlShape } from 'react-intl';

import { type FieldProps } from './BaseTextField';
import useSettings from '../../hooks/useSettings';

interface ValidationsProps {
	validations: FieldProps<any>['validations'];
	validationErrors: ({ t, intl }: { t: TFunction; intl: IntlShape }) => FieldProps<any>['validationErrors'];
}

export default function withFormsyValidations<
	T extends Omit<FieldProps<any>, 'setValue' | 'isFormSubmitted' | 'isPristine' | 'isValid'>
>(Component: React.ComponentType<T>, { validations, validationErrors }: ValidationsProps) {
	return (componentProps: T) => {
		const { t } = useSettings();
		const intl = useIntl();

		return (
			<Component
				validations={{ ...validations, ...(componentProps.validations || {}) }}
				validationErrors={{ ...validationErrors?.({ t, intl }), ...(componentProps.validationErrors || {}) }}
				{...componentProps}
			/>
		);
	};
}
